import React, { Component } from 'react'

// redux 
import { connect } from 'react-redux'
import ReportActions from '../../../redux/report/actions'

// ui 
import Button from '../../../components/uielements/button'

// icon
import { FaPlusCircle } from 'react-icons/fa'
import { Input, DatePicker } from 'antd'

// check permission 
import { checkCreateReportPermission } from '../../../services/check_permission/check_report'

const { Search } = Input
const { MonthPicker, RangePicker, WeekPicker } = DatePicker

class FilterPanel extends Component {

    _onChangeTime = (e) => {
        try {

            let begin_time = (e[0]._d.valueOf() / 1000) >> 0
            let end_time = (e[1]._d.valueOf() / 1000) >> 0
            this.props.updateTime(begin_time, end_time)
        }
        catch {
            this.props.updateTime(null, null)
        }
    }

    _handleAddClick = () => {
        this.props.setDefaultCurrentReport(this.props.userInfo)
        this.props.showModalReportInfo()
    }

    render() {
        const { userInfo } = this.props
        return (
            <div className="FilterPanel">
                <div className="row">
                    <div className="HeadBar">
                        {
                            checkCreateReportPermission(userInfo) &&
                            <Button
                                type="primary"
                                onClick={() => this._handleAddClick()}
                            >
                                <FaPlusCircle className="iconButton" />
                                Tạo báo cáo
                        </Button>
                        }
                    </div>
                </div>
                <div className="SearchBar">
                    <div>
                        Tìm kiếm
                    </div>
                    <Search
                        className="SearchBox"
                        placeholder="Nhập để tìm kiếm"
                        onSearch={value => this.props.searchHistoryReport()}
                        style={{ width: '90%', marginLeft: 'auto', marginRight: 'auto' }}
                        onChange={e => this.props.updateTextSearch(e.target.value)}
                        value={this.props.textSearch}
                    />

                    <div style={{ marginTop: 10 }}>
                        Lọc theo khoảng thời gian
                    </div>
                    <RangePicker onChange={(e) => this._onChangeTime(e)} style={{ marginLeft: 'auto', marginRight: 'auto' }} format={'DD/MM/YYYY'} />
                </div>
            </div>
        )
    }
}

const mapStatetToProps = state => {
    return {
        textSearch: state.qbreport.history_textSearch,
        userInfo: state.auth.userInfo
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateTextSearch: textSearch => {
            dispatch(ReportActions.action.updateHistoryTextSearch(textSearch))
        },
        searchHistoryReport: () => {
            dispatch(ReportActions.action.searchHistoryReport())
        },
        updateTime: (begin_time, end_time) => {
            dispatch(ReportActions.action.updateHistoryTime(begin_time, end_time))
        },
        setDefaultCurrentReport: userInfo => {
            dispatch(ReportActions.action.setDefaultCurrentReport(userInfo))
        },
        showModalReportInfo: () => {
            dispatch(ReportActions.action.showModalReportInfo())
        }
    }
}

export default connect(mapStatetToProps, mapDispatchToProps)(FilterPanel)